// Tag and donor-name rules agreed on #33926. Kept in step with the API's
// AnimalRepository.ValidateIdentifiers, which enforces the same limits.
export const MAX_TAG_LENGTH = 10;
export const MAX_DONOR_NAME_LENGTH = 43;

const ALLOWED_TAG = /^[A-Za-z0-9 \-*()./]*$/;

/** Problem with a tag, or null when it is valid. Values are trimmed first. */
export const tagProblem = (
  tag: string | undefined | null,
  { checkCharacters = true }: { checkCharacters?: boolean } = {},
): string | null => {
  const value = tag?.trim() ?? '';
  if (value.length > MAX_TAG_LENGTH)
    return `Keep the tag to ${MAX_TAG_LENGTH} characters or fewer`;
  if (checkCharacters && !ALLOWED_TAG.test(value))
    return 'Use letters, numbers, spaces and - * ( ) . / only';
  return null;
};

export const donorNameProblem = (
  name: string | undefined | null,
): string | null =>
  (name?.trim().length ?? 0) > MAX_DONOR_NAME_LENGTH
    ? `Keep the name to ${MAX_DONOR_NAME_LENGTH} characters or fewer`
    : null;
